export default "__VITE_ASSET__BSF5yjns__"